import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ import useNavigate
import './Login.css';
import logo from './logosidebar.png'; 

const Login = ({ onLogin }) => {
  const navigate = useNavigate(); // ✅ initialize navigate

  const [formData, setFormData] = useState({
    username: '',  // Changed to username
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // API endpoint
    const url = ' https://sadaatagrofarms.com/api/token/';  // Replace with your API endpoint

    // Make the POST request with the credentials
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        username: formData.username,  // Use username here
        password: formData.password
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.access) {
          // Store necessary values in localStorage
          localStorage.setItem('authToken', data.access);
          localStorage.setItem('userRole', data.user_role);
          localStorage.setItem('userId', data.user_id);
          localStorage.setItem('username', formData.username);  // Save username

          // Call parent callback if provided
          if (onLogin) {
            onLogin(data.access);
          }

          // Navigate to home after successful login
          navigate('/');
        } else {
          setError('Invalid username or password');
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Login error:', err);
        setError('Failed to login, please try again');
        setLoading(false);
      });
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
           <img src={logo} alt="Farm Management Logo" className="logo-icon" />
            <h1>SADAAT AGRO FARMS</h1>
          </div>
          <p className="login-subtitle">Sign in to manage your farm</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">Username</label> {/* Changed label to username */}
            <div className="input-wrapper">
              <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <input
                type="text"  // Changed to text for username
                id="username"
                name="username"  // Use username instead of email
                value={formData.username}
                onChange={handleChange}
                placeholder="admin"
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
                disabled={loading}
              />
            </div>
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner"></span>
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        <div className="login-footer">
         
        </div>
      </div>
    </div>
  );
};

export default Login;
